import { createGlobalState } from 'react-use';

const useGlobalCamAdRunningState = createGlobalState<boolean>(false);

const useCamAdRunning = () => useGlobalCamAdRunningState();

export default useCamAdRunning;
